import PortalIdParser from 'PortalIdParser';
import { registerQuery } from 'data-fetching-client';
import userInfo from 'hub-http/userInfo';
import { logRavenException } from '../../../utils/ravenWrapperUtil';
export const AUTH_FIELD_NAME = 'auth';
const getAuth = () => {
  PortalIdParser.get();
  return userInfo().catch(error => {
    logRavenException(error, 'Fetch auth');
    return null;
  });
};
export const GET_AUTH = registerQuery({
  fieldName: AUTH_FIELD_NAME,
  async fetcher() {
    return await getAuth();
  }
});